import { createTempUrl, exposeWindow } from './_debugger';
import init from './_lab';

/** Lab plugin. */
const labPlugin = {
  init,
  exposeWindow,
  createTempUrl,
};

export default labPlugin;
